/* eslint-disable no-undef */
<template>
  <div class="hello ">

    <p>blur: {{blur}}</p>
    <div class="webcam_capture" ref="webcam_capture" :style="heightStyle">
      <p class="video-message" :class="{'text-highlight':highlightText, 'video-message-bottom': detectTop}"
         v-if="instruction!==''"><b>{{
          instruction
        }}</b></p>
      <vue-ellipse-progress
          v-if="totalProgress > 0"
          :progress="totalProgress"
          line="butt"
          :color="emptyColor"
          empty-color="#324c7e"
          :empty-color-fill="emptyColorFill"
          thickness="45"
          emptyThickness="20"
          :size="70"
          dash="strict 4 0.98"
          lineMode="in-over"
          animation="loop 500 100"
      >
      </vue-ellipse-progress>

      <canvas ref="canvasOutput" class="center-block" id="canvasOutput" :style="heightStyle"></canvas>
      <video @canplay="canplayVideoHandler" ref="video" id="video" :style="heightStyle" muted>
        Your browser does not support
        the video tag.
      </video>
      <div style="position: absolute;top: 50%;left: 44%" class="text-center" v-if="!streaming">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <p>Loading</p>
      </div>


    </div>

    <div class="invisible">
      <canvas ref="canvasBuffer" id="canvasBuffer"></canvas>
    </div>


  </div>
</template>

<script>
import {VueEllipseProgress} from 'vue-ellipse-progress';
import * as Sentry from "@sentry/vue";
import * as tf from '@tensorflow/tfjs-core';

export default {
  name: "CardCaptureNew",
  props: {
    msg: String
  },
  components: {
    VueEllipseProgress,
  },
  data() {
    return {
      emptyColor: {
        radial: true,
        colors: [
          {
            color: "#7579ff",
            offset: "0",
            opacity: "0.1",
          },
          {
            color: "#7579ff",
            offset: "100",
            opacity: 0.5,
          },
        ],
      },
      emptyColorFill: {
        radial: true,
        colors: [
          {
            color: "#3260FC",
            offset: "0",
            opacity: 0,
          },
          {
            color: "#3260FC",
            offset: "100",
            opacity: 0.1,
          },
        ],
      },
      highlightText: false,
      heightStyle: {
        height: "300px !important"
      },
      rectROI: {},
      errCount: 0,
      videoWidth: {},
      videoHeight: {},
      video: {},
      canvasOutput: {},
      canvasOutputCtx: {},
      stream: null,
      canvasBuffer: null,
      canvasBufferCtx: null,
      roiX: 0,
      roiY: 0,
      roiWidth: 0,
      roiHeight: 0,
      capturedImage: "",
      recordedChunks: [],
      recordVideo: {},

      streaming: false,//state management
      referenceFrame: null,//state management
      referenceFrameUploaded: false,//state management
      backFrameRequired: true, //state management
      backFrameUploaded: false, //state management
      gettingBackside: null,//state management
      backDetected: false, //state management
      docAuthenticityRequired: true, //state management
      authenticated: "working", // state management
      authenticationProgress: 0,//state management
      torchTurnedOn: false, //state management
      blur:0,
      blurThreshold:0,
      detectTop: false,
      detectBottom: false,
      totalAuthFrames: 0,
      changePlaceholder: false,
    };
  },
  watch: {
    instruction: function (val) {
      this.highlightText = true;
      setTimeout(() => {
        this.highlightText = false;
      }, 3000)
    },
  },

  mounted() {

    this.video = this.$refs.video;
    this.canvasOutput = this.$refs.canvasOutput;
    this.canvasOutputCtx = this.canvasOutput.getContext("2d");
    this.canvasBuffer = this.$refs.canvasBuffer;
    this.readStepConfig()

    this.startCamera();
    this.$once("hook:beforeDestroy", function () {
      this.endExecution();
    });
  },
  computed: {
    totalProgress() {
      if (this.docAuthenticityRequired === false && this.backFrameRequired === false) {
        if (this.referenceFrameUploaded === true) {
          return 100;
        }
        if (this.referenceFrame !== null) {
          return 50;
        }
        return 0;
      }
      if (this.docAuthenticityRequired === true && this.backFrameRequired === false) {
        if (this.referenceFrame === null) {
          return 0;
        } else if (this.referenceFrameUploaded === false) {
          return 10;
        } else {
          if ([true, "pending", false].includes(this.authenticated)) {
            return 100;
          } else {
            return Math.round((this.authenticationProgress * 0.8) + 20)
          }
        }
      }
      if (this.docAuthenticityRequired === true && this.backFrameRequired === true) {
        if (this.referenceFrame === null) {
          return 0;
        } else if (this.referenceFrameUploaded === false) {
          return 10;
        } else {
          if ([true, "pending", false].includes(this.authenticated)) {
            if (this.backDetected === true){
              return 100;
            }
            return 80;
          } else {
            return Math.round((this.authenticationProgress * 0.6) + 20)
          }
        }
      }
      if (this.docAuthenticityRequired === false && this.backFrameRequired === true) {
        if (this.referenceFrame === null) {
          return 0;
        } else if (this.referenceFrameUploaded === false) {
          return 10;
        } else {
          if (this.backDetected === true) {
            return 100;
          }
          return 50;
        }
      }
      return 0;
    },
    authenticityDone() {
      return [true, "pending", false].includes(this.authenticated)
    },
    instruction(){
      if (!this.streaming) {
        return this.$t("cameraWaitMsg");
      }
      if (this.blur<=this.blurThreshold){
        return this.$t("blurImageMsg")
      }
      if (this.docAuthenticityRequired === false && this.backFrameRequired === false) {
        if (this.referenceFrameUploaded === true) {
          return this.$t("waitMsg");
        }
        if (this.referenceFrame !== null) {
          return this.$t("uploading");

        }
        return this.$t("bringCardInBox");
      }
      if (this.docAuthenticityRequired === true && this.backFrameRequired === false) {
        if (this.referenceFrame === null) {
          return this.$t("bringCardInBox");
        } else if (this.referenceFrameUploaded === false) {
          return this.$t("uploading");
        } else {
          if ([true, "pending", false].includes(this.authenticated)) {
            return this.$t("waitMsg");
          } else {
            return this.$t("keepCardInBox")
          }
        }
      }
      if (this.docAuthenticityRequired === true && this.backFrameRequired === true) {
        if (this.referenceFrame === null) {
          return this.$t("bringCardInBox");
        } else if (this.referenceFrameUploaded === false) {
          return this.$t("uploading");
        } else {
          if ([true, "pending", false].includes(this.authenticated)) {
            if (this.backDetected === true){
              return this.$t("waitMsg");
            }
            return this.$t("bringBackCardInBox");
          } else {
            return this.$t("keepCardInBox")
          }
        }
      }
      if (this.detectTop) {
        return this.$t("moveCardUpward")
      } else if (this.detectBottom) {
        return this.$t("moveCardDownward")
      }
      return ""
    }
  },
  methods: {
    readStepConfig() {

      const currentStep = this.$store.state.config[this.$store.state.step - 1]
      this.docAuthenticityRequired = currentStep.step_config.document_authenticity || false
      this.backFrameRequired = currentStep.step_config.document_backside_capture || false
    },
    endExecution() {

      this.streaming = false;
      this.stream.getTracks().forEach(function (track) {
        track.stop();
      });

    },
    getBackCameraDeviceID(devices) {
      devices = devices.filter(device => device.kind === "videoinput")
      let filtered_devices = devices.filter(device => device.label.includes("facing back"))
      if (filtered_devices.length <= 0) {
        filtered_devices = devices.filter(device => device.label.includes("Back Camera"))
      }
      let device_id = null;
      if (filtered_devices.length > 0) {
        device_id = filtered_devices[filtered_devices.length - 1].deviceId
      } else {
        device_id = devices[0].deviceId
      }
      return device_id
    },
    handleError(err) {

      if (err.response.status === 400) {
        if ('non_field_errors' in err.response && err.response.non_field_errors.length > 0) {
          this.showError(err.response.non_field_errors[0])
        } else if ('data' in err.response) {
          if ('non_field_errors' in err.response.data && err.response.data.non_field_errors.length > 0) {
            this.showError(err.response.data.non_field_errors[0])
          } else {
            this.showError(JSON.stringify(err.response.data))
          }

        } else {
          this.showError(JSON.stringify(err.response))
        }
      } else if (err.response && err.response.status === 401) {
        this.$router.push('/expired')
      } else {
        this.showError(JSON.stringify(err.response))
      }
    },
    uploadRecordingVideo() {
      let formData = new FormData();
      formData.append("video", this.recordVideo, `${this.$store.state.session_id}_video`);
      formData.append("session", this.$store.state.session_id);
      this.$http.post("/upload-authentication-video", formData).then(res => {
      }).catch(err => {
        this.handleError(err)
      });
    },

    startRecording() {
      const options = {mimeType: "video/webm", videoBitsPerSecond: 1750000};
      let mediaRecorder = new MediaRecorder(this.stream, options);

      mediaRecorder.addEventListener("start", () => {
      });
      mediaRecorder.addEventListener("dataavailable", e => {
        if (e.data.size > 0) {
          this.recordedChunks.push(e.data);
        }
      });

      mediaRecorder.addEventListener("stop", () => {
        this.processRecordedVideo();
        this.uploadRecordingVideo()
      });

      mediaRecorder.start();
    },
    startCamera: function () {
      if (this.streaming) return;
      navigator.mediaDevices.enumerateDevices().then(devices => {

        let device_id = this.getBackCameraDeviceID(devices)
        navigator.mediaDevices.getUserMedia({
          video: {
            deviceId: device_id,
            // facingMode: "environment",
            width: {ideal: 960},
            height: {ideal: 720},
            focusMode: 'continuous'
          },
          audio: false
        }).then(s => {

          this.stream = s;
          this.video.srcObject = s;
          this.video.play();
          this.startRecording()
        }).catch(err => {
          this.showError(err.response)
        });
      })

    },
    processRecordedVideo() {
      try {

        let blob = new Blob(this.recordedChunks);
        this.recordVideo = blob;
      } catch (e) {
        if (this.errCount > 5) {
          alert(e);
        } else {
          this.errCount += 1
          this.processRecordedVideo();
        }
      }
    },

    calculateRoi() {
      if (this.videoWidth < this.videoHeight) {

        this.roiWidth = Math.round(this.videoWidth / 1)//maybe delete this divide
        this.roiHeight = Math.round(this.roiWidth * 0.6667)


        let vidXmid = this.videoWidth / 2
        let vidymid = this.videoHeight / 2
        this.roiX = Math.round(vidXmid - (this.roiWidth / 2))
        this.roiY = Math.round(vidymid - (this.roiHeight / 2))

      } else {
        this.roiHeight = Math.round(this.videoHeight)
        this.roiWidth = Math.round(this.roiHeight * 1.5)
        let vidXmid = this.videoWidth / 2
        let vidymid = this.videoHeight / 2
        this.roiX = Math.round(vidXmid - (this.roiWidth / 2))
        this.roiY = Math.round(vidymid - (this.roiHeight / 2))
      }

      let gtBox = {
        xMin: 0,
        yMin: 0,
        xMax: this.roiWidth,
        yMax: this.roiHeight,
        area: this.roiHeight * this.roiWidth
      }
      this.rectROI = new this.$cv.Rect(this.roiX, this.roiY, this.roiWidth, this.roiHeight);


    },
    fixCanvasOverlay() {
      this.video.setAttribute("width", this.videoWidth);
      this.video.setAttribute("height", this.videoHeight);

      let newHeight = (this.videoHeight / this.videoWidth) * this.video.clientWidth;
      this.heightStyle = {
        height: newHeight + "px !important"
      }
      this.$forceUpdate();
      this.canvasOutput.width = this.videoWidth;
      this.canvasOutput.height = this.videoHeight;
    },
    canplayVideoHandler: function (ev) {
      if (!this.streaming) {
        this.videoWidth = this.video.videoWidth;
        this.videoHeight = this.video.videoHeight;
        // this.calculateRoi()
        this.fixCanvasOverlay()
        this.streaming = true;
      }
      this.startVideoProcessing();
    },
    initializeCanvases() {
      // this.canvasBuffer = document.createElement("canvas");
      this.canvasBuffer.width = this.videoWidth;
      this.canvasBuffer.height = this.videoHeight;
      this.canvasBufferCtx = this.canvasBuffer.getContext("2d");

    },
    startVideoProcessing: function () {
      if (!this.streaming) {
        console.warn("Please startup your webcam");
        return;
      }
      this.initializeCanvases()
      requestAnimationFrame(this.processVideo);
    },
    drawOverlay() {
      this.canvasOutputCtx.lineWidth = 3;
      this.canvasOutputCtx.globalAlpha = 0.6
      this.canvasOutputCtx.beginPath()
      if (this.detectTop) {
        this.canvasOutputCtx.rect(0, 0, this.videoWidth, this.videoHeight * 0.5);
      } else if (this.detectBottom) {
        this.canvasOutputCtx.rect(0, this.videoHeight * 0.5, this.videoWidth, this.videoHeight);
      } else {
        this.canvasOutputCtx.rect(0, this.videoHeight * 0.2, this.videoWidth, this.videoHeight * 0.6);
      }
      this.canvasOutputCtx.rect(this.videoWidth, 0, -this.videoWidth, this.videoHeight);
      this.canvasOutputCtx.fill()
      this.canvasOutputCtx.lineWidth = 20;
      this.canvasOutputCtx.strokeStyle = "white";
      this.canvasOutputCtx.globalAlpha = 1
      this.canvasOutputCtx.beginPath()

      // this.canvasOutputCtx.moveTo(this.roiX + 20, this.roiY + 30);
      // this.canvasOutputCtx.lineTo(this.roiX + 80, this.roiY + 30);
      // this.canvasOutputCtx.moveTo(this.roiX + 30, this.roiY + 30);
      // this.canvasOutputCtx.lineTo(this.roiX + 30, this.roiY + 80);
      //
      //
      // this.canvasOutputCtx.moveTo(this.roiX + this.roiWidth - 20, this.roiY + 30);
      // this.canvasOutputCtx.lineTo(this.roiX + this.roiWidth - 80, this.roiY + 30);
      // this.canvasOutputCtx.moveTo(this.roiX + this.roiWidth - 30, this.roiY + 30);
      // this.canvasOutputCtx.lineTo(this.roiX + this.roiWidth - 30, this.roiY + 80);
      //
      // this.canvasOutputCtx.moveTo(this.roiX + 20, this.roiY - 30 + this.roiHeight);
      // this.canvasOutputCtx.lineTo(this.roiX + 80, this.roiY - 30 + this.roiHeight);
      // this.canvasOutputCtx.moveTo(this.roiX + 30, this.roiY - 30 + this.roiHeight);
      // this.canvasOutputCtx.lineTo(this.roiX + 30, this.roiY - 30 + this.roiHeight - 50);
      //
      // this.canvasOutputCtx.moveTo(this.roiX + this.roiWidth - 20, this.roiY + this.roiHeight - 30);
      // this.canvasOutputCtx.lineTo(this.roiX + this.roiWidth - 50 - 30, this.roiY + this.roiHeight - 30);
      // this.canvasOutputCtx.moveTo(this.roiX + this.roiWidth - 30, this.roiY + this.roiHeight - 20);
      // this.canvasOutputCtx.lineTo(this.roiX + this.roiWidth - 30, this.roiY + this.roiHeight - 50 - 30);

      this.canvasOutputCtx.stroke();

    },
    drawReferenceFrameOnOutput() {

      let toBeDrawn = this.referenceFrame.clone()

      this.$cv.imshow(this.canvasOutput, toBeDrawn);
      let newHeight = this.video.clientWidth / 1.57;

      this.heightStyle = {
        height: newHeight + "px !important"
      }

      toBeDrawn.delete();
      this.capturedImage = this.canvasOutput.toDataURL();
    },
    processVideo: async function () {
      if (!this.streaming) {
        return;
      }
      this.canvasOutputCtx.clearRect(0, 0, this.canvasOutput.width, this.canvasOutput.height);

      if (this.totalProgress >= 100) {
        this.endExecution();
        this.drawReferenceFrameOnOutput()
        this.$emit("captureComplete", this.capturedImage);
        return;
      }
      const gettingAuthenticationFrames = this.referenceFrameUploaded === true && this.docAuthenticityRequired === true
          && this.torchTurnedOn === true && this.authenticityDone === false
      if (this.changePlaceholder && gettingAuthenticationFrames) {
        if (this.totalAuthFrames < 3) {
          this.detectBottom = true
        } else {
          this.detectTop = true
          this.detectBottom = false
        }
      }
      this.drawOverlay()

      let srcMatGlobal = this.getVideoFrameMatrix();

      let resizedSrcImage = new this.$cv.Mat();
      this.$cv.resize(srcMatGlobal, resizedSrcImage, new this.$cv.Size(0, 0),1/3.75,1/5,this.$cv.INTER_LINEAR);
      this.$cv.cvtColor(resizedSrcImage, resizedSrcImage, this.$cv.COLOR_BGRA2BGR);


      let modelInput = tf.tensor(resizedSrcImage.data, [resizedSrcImage.rows, resizedSrcImage.cols, 3])
      // console.log("----1")
      modelInput = tf.expandDims(modelInput,0)
      // console.log("----2")
      let outputTensor = await this.$objectDetector.predict(modelInput);
      // console.log("----3")
      let boxes_raw = outputTensor['TFLite_Detection_PostProcess'].dataSync()
      let confidence = outputTensor['TFLite_Detection_PostProcess:2'].dataSync()[0]
      console.log(confidence)

      if (confidence <= 0.3) {
        requestAnimationFrame(this.processVideo)
        return
      }
      let ymin = Math.round(boxes_raw[0] * 960)
      let xmin = Math.round(boxes_raw[1] * 720)
      let ymax = Math.round(boxes_raw[2] * 960)
      let xmax = Math.round(boxes_raw[3] * 720)

      this.roiX = xmin-20;
      this.roiY = ymin-30;
      this.roiWidth = xmax-xmin+40;
      this.roiHeight = ymax-ymin+60;

      console.log("---before roi")
      this.rectROI = new this.$cv.Rect(this.roiX, this.roiY, this.roiWidth, this.roiHeight);
      let srcMatROI;
      try {
        srcMatROI = this.getROIFrameMatrix(srcMatGlobal)
        console.log("after roi")

      }
      catch (e){
        requestAnimationFrame(this.processVideo)
        return
      }
      this.canvasOutputCtx.lineWidth = 2

      const {lowerCanny, upperCanny} = this.getAutoCanny(srcMatROI)
      let grayMat = new this.$cv.Mat(this.roiHeight, this.roiWidth, this.$cv.CV_8UC1);

      this.$cv.cvtColor(srcMatROI, grayMat, this.$cv.COLOR_BGR2GRAY);

      let edgeFrame = this.getEdgeFrame(grayMat, lowerCanny, upperCanny)
      this.$cv.resize(edgeFrame, edgeFrame, new this.$cv.Size(0, 0), 1 / 2.25, 1 / 2.25, this.$cv.INTER_LINEAR);  // agr 1080 k image ha tu 480 o jate ha
      let houghLines = this.getHoughlines(edgeFrame)

      let lu = this.getTopHoughlines(houghLines);

      let detectedRectangles = []
      //should work for 4 to 8 lines only
      if (lu.length >= 4) {

        //seperates horizontal and vertical lines from the lines.
        let [top_lines, bottom_lines, left_lines, right_lines, horizontal_lines, vertical_lines] = this.line_hor_ver(lu);
        detectedRectangles = this.getDetectedRectangles(top_lines, bottom_lines, left_lines, right_lines)
      }
      detectedRectangles.sort((rect1, rect2) => {
        rect2.area - rect1.area;
      })

      if (detectedRectangles.length > 0) {
        let detectedRectangle = detectedRectangles[0];
        this.canvasOutputCtx.lineWidth = 2
        this.canvasOutputCtx.strokeStyle = "red"
        console.log("----drawing----",detectedRectangle)
        this.canvasOutputCtx.strokeRect(detectedRectangle.xMin+this.roiX,detectedRectangle.yMin+this.roiY,
            detectedRectangle.maxW,detectedRectangle.maxH)

        let refImage = this.rectifyImageToRefFrame(srcMatROI, detectedRectangle)

        let aspectRatio = this.calculateAspectRatio(detectedRectangle);
        // let iou = this.calculateIOU(detectedRectangle)
        console.log('aspect ratio', aspectRatio)
        this.blur = this.calculateBlur(refImage)
        if ((1.50 <= aspectRatio) && (aspectRatio <= 1.68)) {
          if (this.referenceFrame === null) {
            this.blurThreshold = 5;
            if (this.blur >= this.blurThreshold) {
              this.referenceFrame = refImage.clone();
              let base64Image = this.getBase64Image(this.referenceFrame)
              let url = '/upload-reference-frame'
              this.uploadImageFrame(url, base64Image).then(res => {
                this.changePlaceholder = res.data.change_placeholder
                if (this.docAuthenticityRequired === true) {
                  // Turn on torch
                  if (this.authenticityDone === false) {
                    this.turnTorchOnOff()
                  }
                } else if (this.backFrameRequired === true) {
                  this.backFramePrompt()
                }
                this.referenceFrameUploaded = true
              }).catch(err => {
                this.handleError(err)
                this.referenceFrame = null
              })

            }

          } else if (gettingAuthenticationFrames) {

            let base64Image = this.getBase64Image(refImage)
            let url = '/upload-authentication-frame'
            try {
              let res = await this.uploadImageFrame(url, base64Image)
              this.totalAuthFrames += 1
              this.authenticated = res.data.authenticated;
              this.authenticationProgress = Math.round(parseFloat(res.data.percentage))
              if (this.authenticityDone === true && this.backFrameRequired === true) {
                this.backFramePrompt()
              }

            } catch (err) {
              this.handleError(err)
            }


          } else if (this.backFrameRequired === true && this.gettingBackside === true && this.backDetected === false) {
            this.blurThreshold = 6.5;
            if (this.blur >= this.blurThreshold) {
              let base64Image = this.getBase64Image(refImage)
              let url = '/upload-back-frame'
              try {
                this.gettingBackside = false
                let res = await this.uploadImageFrame(url, base64Image)
                this.backDetected = true


              } catch (err) {
                this.handleError(err)
              }
            }

          }

        }
        refImage.delete()

      }

      grayMat.delete();
      srcMatROI.delete();
      edgeFrame.delete();
      houghLines.delete();
      srcMatGlobal.delete();
      resizedSrcImage.delete();
      outputTensor = null;
      boxes_raw = null;
      lu = null;

      requestAnimationFrame(this.processVideo);
    },
    turnTorchOnOff(torchOn = true) {
      const track = this.stream.getVideoTracks()[0];
      const imageCapture = new ImageCapture(track)
      imageCapture.getPhotoCapabilities().then((photoCapabilities) => {
        if (photoCapabilities.fillLightMode) {
          track.applyConstraints({
            advanced: [{torch: torchOn}]
          }).then(res => {
            this.torchTurnedOn = torchOn
          });
        }
      })
    },
    drawResults: function (ctx, results, color, size) {
      for (let i = 0; i < results.length; ++i) {
        let rect = results[i];
        let xRatio = this.videoWidth / size.width;
        let yRatio = this.videoHeight / size.height;
        ctx.lineWidth = 3;
        ctx.strokeStyle = color;
        ctx.strokeRect(rect.x * xRatio, rect.y * yRatio, rect.width * xRatio, rect.height * yRatio);
      }
    },
    findIntersection: function (lines) {
      //finds all the possible intersecting points of all the lines passed by solving the matrix X matrix in equation ax = b
      let intersections = [];
      for (let g = 0; g < lines.length - 1; ++g) {
        let line1 = lines[g];
        for (let g2 = g + 1; g2 < lines.length; ++g2) {
          let line2 = lines[g2];
          if (this.intersection(line1, line2))
            intersections.push(this.intersection(line1, line2));
        }
      }
      return intersections;
    },

    intersection: function (line1, line2) {
      let rho1 = line1[0];
      let theta1 = line1[1];
      let rho2 = line2[0];
      let theta2 = line2[1];

      if (Math.abs(theta1 - theta2) > 1.3) {
        let det = Math.cos(theta1) * Math.sin(theta2) - Math.sin(theta1) * Math.cos(theta2);
        let x0 = (rho1 * Math.sin(theta2) - rho2 * Math.sin(theta1)) / det;
        let y0 = (-rho1 * Math.cos(theta2) + rho2 * Math.cos(theta1)) / det;
        x0 = Math.round(x0);
        y0 = Math.round(y0);
        return ([x0, y0]);
      }
    },

    radians_to_degrees: function (radians) {
      return radians * (180 / Math.PI);
    },
    between: function (value, min, max) {
      //make sure value is in a range
      return value >= min && value <= max;
    },
    line_is_straight: function (angle) {
      // detects if a line is straight using its angle
      let range = 5
      return (this.between(angle, 0, range) || this.between(angle, 90 - range, 90 + range) || this.between(angle, 180 - range, 180 + range) || this.between(angle, 270 - range, 270 + range) || this.between(angle, 360 - range, 360))
    },
    line_hor_ver: function (lines) {
      //seperates lines into vertical and horizontal lines based on line angle
      let range = 5;
      let horizontal_lines = [];
      let vertical_lines = [];
      let top_lines = [];
      let bottom_lines = [];
      let left_lines = [];
      let right_lines = [];
      for (let i = 0; i < lines.length; ++i) {
        let angle = lines[i][2];
        let rho = lines[i][0];
        if (this.between(angle, 0, range) || this.between(angle, 180 - range, 180 + range || this.between(angle, 360 - range, 360))) {
          if (this.between(rho, 0, (this.roiWidth / 2.25) * 0.35)) {
            left_lines.push(lines[i])
          }
          if (this.between(rho, (this.roiWidth / 2.25) * 0.65, (this.roiWidth / 2.25))) {
            right_lines.push(lines[i])
          }
          vertical_lines.push(lines[i]);

        } else if (this.between(angle, 90 - range, 90 + range) || this.between(angle, 270 - range, 270 + range)) {
          if (this.between(rho, 0, (this.roiHeight / 2.25) * 0.35)) {
            top_lines.push(lines[i])
          }
          if (this.between(rho, (this.roiHeight / 2.25) * 0.65, (this.roiHeight / 2.25))) {
            bottom_lines.push(lines[i])
          }
          horizontal_lines.push(lines[i]);

        }
      }
      return ([top_lines, bottom_lines, left_lines, right_lines, horizontal_lines, vertical_lines]);
      // return ([horizontal_lines, vertical_lines]);
    },
    showManualPopup() {
      const options = {
        title: this.$t("cardNotVerified"),
        text: this.$t("manuallyVerify"),
        icon: "question",
        showCancelButton: true,

        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("no"),
        allowOutsideClick: false,
        allowEscapeKey: false,
        focusConfirm: false,
        customClass: {
          confirmButton: "btn btn-primary btn-md ripple-parent",
          cancelButton: "btn  btn-md ripple-parent"
        },
        buttonsStyling: false,
      };
      return this.$swal.fire(options)
    },
    showError(message, cancelButton = false) {

      const options = {
        title: message,
        text: this.$t("retryQuestion"),
        icon: 'question',
        showCancelButton: cancelButton,

        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("no"),
        allowOutsideClick: false,
        allowEscapeKey: false,
        focusConfirm: false,
        customClass: {
          confirmButton: "btn btn-primary btn-md ripple-parent",
          cancelButton: "btn  btn-md ripple-parent"
        },
        buttonsStyling: false,
      };

      this.$swal.fire(options).then(res => {
        if (res.value) {
          window.location.reload();
          // eslint-disable-next-line no-undef
        }
      })
    },
    backFramePrompt() {
      const options = {
        title: this.$t("backFrame"),
        text: "",
        icon: "success",
        showCancelButton: false,

        confirmButtonText: "Ok",
        cancelButtonText: this.$t("no"),
        allowOutsideClick: false,
        allowEscapeKey: false,
        focusConfirm: false,
        customClass: {
          confirmButton: "btn btn-primary btn-md ripple-parent",
          cancelButton: "btn  btn-md ripple-parent"
        },
        buttonsStyling: false,
      };

      if (this.torchTurnedOn === true) {
        this.turnTorchOnOff(false)
      }

      this.$swal.fire(options).then(res => {
        if (res.value) {

          this.gettingBackside = true
          this.canplayVideoHandler()
        }
      })
    },
    getVideoFrameMatrix() {
      let srcMat = new this.$cv.Mat(this.videoHeight, this.videoWidth, this.$cv.CV_8UC4);
      //todo: improve way of reading image
      this.canvasBufferCtx.drawImage(this.video, 0, 0, this.videoWidth, this.videoHeight);
      let imageData = this.canvasBufferCtx.getImageData(0, 0, this.videoWidth, this.videoHeight);
      srcMat.data.set(imageData.data);
      return srcMat;
    },
    getROIFrameMatrix(srcMatFull) {

      let srcMatROI = srcMatFull.roi(this.rectROI);
      return srcMatROI

    },
    getEdgeFrame(grayMat, lowerCanny, upperCanny) {

      let dilation = new this.$cv.Mat();
      let kernel = this.$cv.Mat.ones(5, 5, this.$cv.CV_8U);
      let anchor = new this.$cv.Point(-1, -1);


      this.$cv.dilate(grayMat, dilation, kernel, anchor, 5);
      let blur = new this.$cv.Mat();
      let ksize = new this.$cv.Size(3, 3);
      this.$cv.GaussianBlur(dilation, blur, ksize, 0);

      let eroded = new this.$cv.Mat();
      this.$cv.erode(blur, eroded, kernel, anchor, 5);

      // console.log('lowerCanny: ', lowerCanny)
      // console.log('upperCanny: ', upperCanny)
      let edge = new this.$cv.Mat();
      this.$cv.Canny(eroded, edge, lowerCanny, upperCanny, 3);
      dilation.delete();
      kernel.delete();
      blur.delete();
      eroded.delete();

      return edge
    },
    getAutoCanny(srcMatROI, sigma=0.33) {
      let hsv = new this.$cv.Mat(this.roiHeight, this.roiWidth, this.$cv.CV_8UC3)
      let hsvPlanes = new this.$cv.MatVector();

      this.$cv.cvtColor(srcMatROI, hsv, this.$cv.COLOR_BGR2HSV);
      this.$cv.split(hsv, hsvPlanes)
      const v = this.calculateMedian(hsvPlanes.get(2).data)

      hsv.delete()
      hsvPlanes.delete()
      // console.log(grayMatArray.length)
      // console.log('median: ', v)
      // const lower = parseInt(Math.max(0, (1.0 - sigma) * v))
      const lower = 0
      const upper = parseInt(Math.min(255, (1.0 + sigma) * v))
      return {lowerCanny: lower, upperCanny: upper}
    },
    calculateMedian(arr) {
      let mid = Math.floor(arr.length / 2),
          nums = arr.sort((a, b) => a - b);
      const median = arr.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
      nums = null
      arr = null
      return median
    },
    getHoughlines(edgeFrame) {
      let lines = new this.$cv.Mat();
      // let thresh = Math.round(this.roiHeight * 0.15);
      let thresh = 0;
      this.$cv.HoughLines(edgeFrame, lines, 1, Math.PI / 180, thresh);
      return lines;
    },
    getTopHoughlines(houghLines, no_of_lines = 50) {
      let lu = []
      let lines_to_iterate = no_of_lines;
      if (houghLines.rows <= no_of_lines) {
        lines_to_iterate = houghLines.rows;
      }

      for (let i = 0; i < lines_to_iterate; ++i) {

        let rho = houghLines.data32F[i * 2];
        let theta = houghLines.data32F[i * 2 + 1];
        let theta_degree = this.radians_to_degrees(theta)
        lu.push([rho, theta, theta_degree]);
      }
      return lu;

    },
    getDetectedRectangles(top_lines, bottom_lines, left_lines, right_lines) {
      let detectedRectangles = []
      let lines_to_intersect = [];//temporary variable for the below loops for the detection of rectangles
      //these four loops find all the possible rectangles
      for (let top = 0; top < top_lines.length; ++top) {
        lines_to_intersect[0] = top_lines[top];
        for (let bottom = 0; bottom < bottom_lines.length; ++bottom) {
          lines_to_intersect[1] = bottom_lines[bottom];
          for (let left = 0; left < left_lines.length; ++left) {
            lines_to_intersect[2] = left_lines[left];
            for (let right = 0; right < right_lines.length; ++right) {
              lines_to_intersect[3] = right_lines[right];

              let it = this.findIntersection(lines_to_intersect);

              if (it.length === 4) {
                //one rectangles is detected
                let s = [];//sum of x and y cordinate of a corner of rectangle
                let d = [];//difference of x and y cordinate of a corner of rectangle
                for (let k = 0; k < it.length; ++k) {
                  s[k] = it[k][0] + it[k][1];
                  d[k] = it[k][0] - it[k][1];
                }
                // sum and difference are used to find the edges of a rectangles such as top left, top right, bottom left and bottom right
                let tl = it[s.indexOf(Math.min.apply(Math, s))];//top left point of rectangle
                let br = it[s.indexOf(Math.max.apply(Math, s))];//bottom right point of rectangle
                let bl = it[d.indexOf(Math.min.apply(Math, d))];//top right point of rectangle
                let tr = it[d.indexOf(Math.max.apply(Math, d))];//bottom left point of rectangle

                tl = tl.map(e => e * 2.25)
                tr = tr.map(e => e * 2.25)
                bl = bl.map(e => e * 2.25)
                br = br.map(e => e * 2.25)


                let xCords = [tl[0], br[0], bl[0], tr[0]]
                let yCords = [tl[1], br[1], bl[1], tr[1]]


                let xMin = Math.min(...xCords)
                let yMin = Math.min(...yCords)

                let xMax = Math.max(...xCords)
                let yMax = Math.max(...yCords)


                let maxW = xMax - xMin
                let maxH = yMax - yMin

                detectedRectangles.push({
                  'tl': tl,
                  'tr': tr,
                  'bl': bl,
                  'br': br,
                  'xMin': xMin,
                  'yMin': yMin,
                  'xMax': xMax,
                  'yMax': yMax,
                  'maxW': maxW,
                  'maxH': maxH,
                  'area': maxW * maxH
                });

              }
            }
          }
        }
      }
      return detectedRectangles
    },
    calculateIOU(detectedRectangle) {

      let xMin = detectedRectangle.xMin;
      let yMin = detectedRectangle.yMin;
      let xMax = detectedRectangle.xMax;
      let yMax = detectedRectangle.yMax;

      let maxW = detectedRectangle.maxW;
      let maxH = detectedRectangle.maxH;


      let boxAArea = maxH * maxW;
      let gtBox = {
        xMin: 0,
        yMin: 0,
        xMax: this.roiWidth,
        yMax: this.roiHeight,
        area: this.roiHeight * this.roiWidth
      }

      let xA = Math.max(xMin, gtBox.xMin)
      let yA = Math.max(yMin, gtBox.yMin)
      let xB = Math.min(xMax, gtBox.xMax)
      let yB = Math.min(yMax, gtBox.yMax)

      let interArea = Math.max(0, (xB - xA + 1)) * Math.max(0, (yB - yA + 1))


      let boxBArea = gtBox.area;

      let iou = interArea / (boxAArea + boxBArea - interArea)
      return iou
    },
    calculateAspectRatio(detectedRectangle) {
      let maxW = detectedRectangle.maxW;
      let maxH = detectedRectangle.maxH;
      return maxW / maxH;
    },
    rectifyImageToRefFrame(srcMatROI, detectedRectangle) {
      let tl = detectedRectangle.tl;
      let br = detectedRectangle.br;
      let bl = detectedRectangle.bl;
      let tr = detectedRectangle.tr;
      let refImage = new this.$cv.Mat(641, 1000, this.$cv.CV_8UC1);
      //here perspective transformation is being done
      let oldPts = this.$cv.matFromArray(4,
          1, this.$cv.CV_32FC2, [tl[0], tl[1], tr[0], tr[1], br[0], br[1], bl[0], bl[1]]);
      let newPts = this.$cv.matFromArray(4,
          1, this.$cv.CV_32FC2, [0, 0, 1000, 0, 1000, 641, 0, 641]);

      let M = this.$cv.getPerspectiveTransform(oldPts, newPts);
      let dsize = new this.$cv.Size(1000, 641);
      this.$cv.warpPerspective(srcMatROI, refImage, M, dsize); //scan
      return refImage
    },
    calculateBlur(refImage) {
      let blurCalculationRoi = new this.$cv.Rect(220, 100, 750 - 220, 640 - 100);
      let blurCalculationImage = refImage.roi(blurCalculationRoi);
      let blurCalculationLaplacian = new this.$cv.Mat();
      let blurCalculationMen = new this.$cv.Mat();
      let blurCalculationMenO = new this.$cv.Mat();
      this.$cv.Laplacian(blurCalculationImage, blurCalculationLaplacian, this.$cv.CV_64F, 1, 1, 0, this.$cv.BORDER_DEFAULT);
      this.$cv.meanStdDev(blurCalculationLaplacian, blurCalculationMenO, blurCalculationMen)
      let blur = blurCalculationMen.data64F[0];
      blurCalculationLaplacian.delete();
      blurCalculationMen.delete();
      blurCalculationMenO.delete();
      blurCalculationImage.delete();
      return blur;
    },
    getBase64Image(referenceFrame) {
      this.$cv.imshow(this.canvasBuffer, referenceFrame);
      const url = this.canvasBuffer.toDataURL("image/jpeg");
      this.initializeCanvases()
      return url
    },
    uploadImageFrame(url, base64Image) {

      let formData = new FormData();
      formData.append("image", base64Image);
      formData.append("session", this.$store.state.session_id);

      return this.$http.post(url, formData)
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
canvas {
  border: 1px solid rgba(0, 0, 0, 0.3);
  /*background-clip: padding-box;*/
}

.animation {
  width: 20% !important;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 15;

}

.invisible {
  display: none;
}

.webcam_capture {
  width: 128% !important;
  position: relative;
  margin-left: -14%;

}

canvas {
  width: 100% !important;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
}

#video {
  width: 100% !important;
  position: absolute;
  top: 0;
  left: 0;
}

.text-red {
  color: red;
}
</style>
